import { InputHTMLAttributes } from 'react'

import s from './Input.module.css'

type Props = InputHTMLAttributes<HTMLInputElement> & {
  type?: 'text' | 'email' | 'url'
  fullWidth?: boolean
  error?: string
  ref?: React.RefObject<HTMLInputElement | null>
}

export const Input = ({
  name,
  type = 'text',
  placeholder,
  fullWidth,
  error,
  value,
  onChange,
  ref,
  ...rest
}: Props) => {
  return (
    <input
      ref={ref}
      name={name}
      className={`${s.input} ${fullWidth ? s.fullWidth : ''} ${
        error ? (error === '-' ? s.isEmpty : s.hasError) : ''
      }`}
      type={type}
      placeholder={placeholder}
      onChange={(e) => {
        if (onChange) {
          onChange(e)
        }
      }}
      value={value}
      {...rest}
      required
    />
  )
}
